import { render } from "./AccountReview.vue?vue&type=template&id=3a7d4994"
import script from "./AccountReview.vue?vue&type=script&lang=js"
export * from "./AccountReview.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__